import { z } from "zod";

import { DbEnum } from "../../../../generated/prisma-enums";

/**
 * Apply Response Handling Body Schema
 *
 * Forces a specific responseHandling value on all currently OPEN chats
 * for a given deployment. Used when an operator changes the deployment's
 * defaultResponseHandling and wants to retroactively apply it to existing chats.
 */
export const ApplyResponseHandlingBodySchema = z.object({
  responseHandling: z.enum(DbEnum.CHAT_RESPONSE_HANDLING_VALUES)
});

/**
 * Apply Response Handling Response Schema
 *
 * Returns the number of chats that were updated.
 */
export const ApplyResponseHandlingResponseSchema = z.object({
  updatedCount: z.number()
});

export type ApplyResponseHandlingBody = z.infer<typeof ApplyResponseHandlingBodySchema>;
export type ApplyResponseHandlingResponse = z.infer<typeof ApplyResponseHandlingResponseSchema>;
